import styled from "styled-components";

export const BettoProfilePageWrapper = styled.div`
	&& {
		::before {
			display: none;
		}
	}
`;
